import { authRequest } from './index.js'

export async function create_ticket(ticket){
  let data
  await authRequest.post(
    'tickets',
    {ticket},
    { headers: {
        'Content-Type': 'application/json'
      }
    }
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log("🚀 ~ create_ticket ~ error:", error)
    data = {error: true, result: error.response.data}
  })
  return data
}

export async function get_faq(faq_id){
  let data
  await authRequest.get(
    'faqs/' + faq_id
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    console.log(error)
    data = {error: true, result: error.response.data}
  })
  return data
}